export const questionsRUS = [
  {
    id: 1,
    question: 'Ваше имя:',
    type: 'input',
    placeholder: 'Введите ваше имя'
  },
  {
    id: 2,
    question: 'Ваш возраст:',
    type: 'input',
    placeholder: 'Введите ваш возраст'
  },
  {
    id: 3,
    type: 'options',
    question: 'Этническая принадлежность:',
    options: [
        {
          id: 1,
          text: 'Европейская',
          value: 0
        },
        {
          id: 2,
          text: 'Африканкая',
          value: 1
        },
        {
          id: 3,
          text: 'Азиатская',
          value: 2
        },
        {
          id: 4,
          text: 'Другая',
          value: 3
        }
      ],
  },
  {
    id: 4,  
    type: 'options',
    question: 'Ваш пол:',
    options: [
        {
          id: 1,
          text: 'Мужской',
          value: 0
        },
        {
          id: 2,
          text: 'Женский',
          value: 1
        },
      ],
  },
  {
    id: 5,
    type: 'options',
    question: 'Как часто вы добавляете фрукты и овощи в свой рацион?',
    options: [
        {
          id: 1,
          text: 'Редко или никогда',
          value: 0
        },
        {
          id: 2,
          text: 'Несколько раз в неделю',
          value: 1
        },
        {
          id: 3,
          text: 'Каждый день',
          value: 2
        },
        {
          id: 4,
          text: '5 и более раз за день',
          value: 3
        }
      ],
    description: 'Основываясь на 16 исследованиях, проведенных с участием более 833 000 человек',
    impact: 'Исследования 16 исследований с участием более 833 000 человек показывают, что каждая дополнительная ежедневная порция фруктов и овощей снижает риск смерти от всех причин на 5%, а польза достигает пика при употреблении пяти порций в день.',
    rate: 74,
    link: 'https://www.bmj.com/content/349/bmj.g4490/',
  },
  {
    id: 6,
    type: 'options',
    question: 'Как часто вы едите обработанную пищу, такую как фастфуд, консервы или замороженные блюда?',
    options: [
        {
          id: 1,
          text: 'Ежедневно',
          value: 0
        },
        {
          id: 2,
          text: 'Несколько раз в неделю или больше',
          value: 1
        },
        {
          id: 3,
          text: 'Один раз в неделю',
          value: 2
        },
        {
          id: 4,
          text: 'Редко или никогда',
          value: 3
        }
      ],
    description: 'На основе 45 исследований, почти 10 миллионов участников',
    impact: 'Анализ 45 исследований с участием почти 10 миллионов человек показал, что повышенное потребление ультраобработанных продуктов значительно увеличивает риск сердечно-сосудистых заболеваний, диабета и других серьезных проблем со здоровьем.',
    rate: 34,
    link: 'https://www.bmj.com/content/384/bmj-2023-077310',
  },
  {
    id: 7,
    type: 'options',
    question: 'Как часто вы употребляете сахар?',
    options: [
        {
          id: 1,
          text: 'Несколько раз в день',
          value: 0
        },
        {
          id: 2,
          text: 'Ежедневно',
          value: 1
        },
        {
          id: 3,
          text: 'Несколько раз в неделю',
          value: 2
        },
        {
          id: 4,
          text: 'Совсем нет',
          value: 3
        }
      ],
    description: 'На основе 73 метаанализов',
    impact: 'Этот вопрос основан на данных 73 исследований, которые показали, что высокое потребление сахара увеличивает риск заболеваний, включая некоторые виды рака, и повышает общую смертность.',
    rate: 34,
    link: 'https://www.bmj.com/content/381/bmj-2022-071609',
  },
  {
    id: 8,
    type: 'options',
    question: 'Сколько воды вы обычно пьете в день?',
    options: [
        {
          id: 1,
          text: 'Меньше 1 стакана',
          value: 0
        },
        {
          id: 2,
          text: '2–5 стаканов',
          value: 1
        },
        {
          id: 3,
          text: '6–9 стаканов',
          value: 2
        },
        {
          id: 4,
          text: '10 или более стаканов',
          value: 3
        }
      ],
    description: 'На основе систематического обзора, Nutrients 2018',
    impact: 'Согласно систематическому обзору, опубликованному в Nutrients в 2018 году, потребление воды играет важную роль в поддержании метаболизма и общего здоровья. Однако индивидуальные потребности зависят от уровня физической активности и условий окружающей среды.',
    rate: 24,
    link: 'https://www.mdpi.com/2072-6643/10/12/1928',
  },
  {
    id: 9,
    type: 'options',
    question: 'Сколько времени вы уделяете кардио каждую неделю? Например, бег, плавание, походы и т.д.',
    options: [
        {
          id: 1,
          text: 'Редко или никогда',
          value: 0
        },
        {
          id: 2,
          text: 'Менее 150 минут',
          value: 1
        },
        {
          id: 3,
          text: '150–300 минут',
          value: 2
        },
        {
          id: 4,
          text: 'Более 300 минут',
          value: 3
        }
      ],
    description: 'На основе 150 обзоров Cochrane, 485,110 участников',
    impact: 'Согласно обзору 150 систематических исследований Cochrane с участием 485 110 человек, регулярные кардионагрузки снижают риск смертности на 13%.',
    rate: 53,
    link: 'https://bmcpublichealth.biomedcentral.com/articles/10.1186/s12889-020-09855-3',
  },
  {
    id: 10,
    type: 'options',
    question: 'Как часто вы занимаетесь силовыми тренировками?',
    options: [
        {
          id: 1,
          text: 'Редко или никогда',
          value: 0
        },
        {
          id: 2,
          text: 'Реже одного раза в неделю',
          value: 1
        },
        {
          id: 3,
          text: '1–2 дня в неделю',
          value: 2
        },
        {
          id: 4,
          text: 'Более 2 дней в неделю',
          value: 3
        }
      ],
    description: 'На основе 16 исследований',
    impact: 'Согласно систематическому обзору и метаанализу 16 исследований, выполнение упражнений для укрепления мышц снижает риск крупных неинфекционных заболеваний и общей смертности на 10–17%.',
    rate: 34,
    link: 'https://bjsm.bmj.com/content/56/13/755',
  },
  {
    id: 11,
    type: 'options',
    question: 'Как часто вы занимаетесь йогой или растяжкой?',
    options: [
        {
          id: 1,
          text: 'Никогда',
          value: 0
        },
        {
          id: 2,
          text: 'Несколько раз в месяц',
          value: 1
        },
        {
          id: 3,
          text: '1–2 раза в неделю',
          value: 2
        },
        {
          id: 4,
          text: '3 или более раз в неделю',
          value: 3
        }
      ],
    description: 'На основе 22 исследований',
    impact: 'Согласно метаанализу 22 исследований, йога значительно улучшает физическую форму и общее состояние здоровья, способствуя долголетию за счёт повышения баланса, гибкости и силы.',
    rate: 15,
    link: 'https://ijbnpa.biomedcentral.com/articles/10.1186/s12966-019-0789-2',
  },
  {
    id: 12,
    type: 'options',
    question: 'Сколько времени в день вы проводите сидя?',
    options: [
        {
          id: 1,
          text: 'Более 8 часов',
          value: 0
        },
        {
          id: 2,
          text: '4–8 часов',
          value: 1
        },
        {
          id: 3,
          text: '2–4 часа',
          value: 2
        },
        {
          id: 4,
          text: 'Менее 2 часов',
          value: 3
        }
      ],
    description: 'На основе 47 исследований',
    impact: 'Согласно систематическому обзору и метаанализу 47 исследований, сидячий образ жизни увеличивает риск сердечно-сосудистых заболеваний, рака и диабета 2 типа.',
    rate: 34,
    link: 'https://pubmed.ncbi.nlm.nih.gov/25599350/',
  },
  {
    id: 13,
    type: 'options',
    question: 'Как часто вы спите более 7 часов?',
    options: [
        {
          id: 1,
          text: 'Никогда',
          value: 0
        },
        {
          id: 2,
          text: '1–2 раза в неделю',
          value: 1
        },
        {
          id: 3,
          text: '3–4 раза в неделю',
          value: 2
        },
        {
          id: 4,
          text: '5 или более раз в неделю',
          value: 3
        }
      ],
    description: 'На основе 16 исследований, 1,3 миллиона участников',
    impact: 'Согласно систематическому обзору 16 исследований с участием более 1,3 миллиона человек, здоровый сон способствует уменьшению риска общей смертности на 24% и снижает риск сердечно-сосудистых заболеваний на 20%.',
    rate: 100,
    link: 'https://academic.oup.com/sleep/article/33/5/585/2454478',
  },
  {
    id: 14,
    type: 'options',
    question: 'Как часто у вас возникают трудности с засыпанием или сохранением сна?',
    options: [
        {
          id: 1,
          text: '5 или более раз в неделю',
          value: 0
        },
        {
          id: 2,
          text: '3–4 раза в неделю',
          value: 1
        },
        {
          id: 3,
          text: '1–2 раза в неделю',
          value: 2
        },
        {
          id: 4,
          text: 'Никогда',
          value: 3
        }
      ],
    description: 'На основе обзора 85 метаанализов',
    impact: 'Согласно обзору 85 метаанализов, плохое качество сна может привести к неблагоприятным последствиям для здоровья, включая диабет, ожирение, сердечно-сосудистые заболевания и т.д.',
    rate: 62,
    link: 'https://www.frontiersin.org/journals/medicine/articles/10.3389/fmed.2021.813943/full',
  },
  {
    id: 15,
    type: 'options',
    question: 'Как часто вы проводите время с друзьями или семьей?',
    options: [
        {
          id: 1,
          text: 'Никогда',
          value: 0
        },
        {
          id: 2,
          text: 'Несколько раз в месяц',
          value: 1
        },
        {
          id: 3,
          text: 'Еженедельно',
          value: 2
        },
        {
          id: 4,
          text: 'Ежедневно',
          value: 3
        }
      ],
    description: 'На основе исследования Гарвардской школы взрослого развития',
    impact: 'Согласно анализу 23 метаанализов, сильная социальная поддержка существенно влияет на улучшения в здоровье и долголетии, снижая риск заболеваний и смертности.',
    rate: 41,
    link: 'https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2021.717164/full',
  },
  {
    id: 16,
    type: 'options',
    question: 'Каков ваш текущий семейный статус?',
    options: [
        {
          id: 1,
          text: 'Разведен(-а)',
          value: 0
        },
        {
          id: 2,
          text: 'Холост/Незамужем',
          value: 1
        },
        {
          id: 3,
          text: 'Женат/Замужем',
          value: 2
        },
        {
          id: 4,
          text: 'В долгосрочных отношениях',
          value: 3
        }
      ],
    description: 'На основе 148 исследований, более 300 000 участников',
    impact: 'Метаанализ 148 исследований с участием более 300 000 человек показывает, что семейное положение значительно влияет на здоровье.',
    rate: 74,
    link: 'https://journals.plos.org/plosmedicine/article?id=10.1371/journal.pmed.1000316',
  },
  {
    id: 17,
    type: 'options',
    question: 'Есть ли у вас дети?',
    options: [
        {
          id: 1,
          text: 'Нет, и не планирую',
          value: 0
        },
        {
          id: 2,
          text: 'Нет, но планирую',
          value: 1
        },
        {
          id: 3,
          text: 'Да, живут дома',
          value: 2
        },
        {
          id: 4,
          text: 'Да, не живут дома',
          value: 3
        }
      ],
    description: 'Основано на мета-анализе 17 исследований',
    impact: 'Мета-анализ 17 исследований показал, что наличие детей улучшает эмоциональное благополучие, но сопровождается стрессом и жизненными трудностями.',
    rate: 74,
    link: 'https://link.springer.com/article/10.1007/s10680-018-9469-1',
  },
  {
    id: 18,
    type: 'options',
    question: 'Поддерживает ли вас ваше окружение, когда Вы нуждаетесь в помощи?',
    options: [
        {
          id: 1,
          text: 'Нет',
          value: 0
        },
        {
          id: 2,
          text: 'Немного',
          value: 1
        },
        {
          id: 3,
          text: 'Достаточно',
          value: 2
        },
        {
          id: 4,
          text: 'Полностью',
          value: 3
        }
      ],
    description: 'Основано на 39 исследованиях, 140 мета-анализах',
    impact: 'На основе результатов Гарвардского исследования взрослого развития, крепкие социальные связи способствуют улучшению физического здоровья, повышению уровня счастья и увеличению продолжительности жизни.',
    rate: 74,
    link: 'https://www.adultdevelopmentstudy.org',
  },
  {
    id: 19,
    type: 'options',
    question: 'Сколько алкогольных напитков вы потребляете в неделю?',
    options: [
        {
          id: 1,
          text: '15 или больше напитков в неделю',
          value: 0
        },
        {
          id: 2,
          text: '8–14 напитков в неделю',
          value: 1
        },
        {
          id: 3,
          text: '1–7 напитков в неделю',
          value: 2
        },
        {
          id: 4,
          text: 'Я не пью',
          value: 3
        }
      ],
    description: 'Основано на 107 исследованиях, 4,8 миллиона участников',
    impact: 'Анализ, опубликованный в BMC Medicine, свидетельствует о том, что регулярное и чрезмерное употребление алкогольных напитков значительно повышает риск развития сердечно-сосудистых заболеваний, болезней печени и некоторых видов рака.',
    rate: 74,
    link: 'https://bmcmedicine.biomedcentral.com/articles/10.1186/s12916-021-02040-2',
  },
  {
    id: 20,
    type: 'options',
    question: 'Употребляете ли Вы никотин (сигареты, вейпы, бездымный табак)?',
    options: [
        {
          id: 1,
          text: 'Ежедневно употребляю',
          value: 0
        },
        {
          id: 2,
          text: 'Периодически употребляю',
          value: 1
        },
        {
          id: 3,
          text: 'Раньше употреблял(-а)',
          value: 2
        },
        {
          id: 4,
          text: 'Никогда не употреблял(-а)',
          value: 3
        }
      ],
    description: 'На основе метаанализа Национального института рака США',
    impact: 'Мета-анализ, проведенный Национальным институтом рака США, показывает, что курение значительно увеличивает риски рака, сердечно-сосудистых заболеваний, инсульта и заболеваний легких.',
    rate: 74,
    link: 'https://www.cancer.gov/about-cancer/causes-prevention/risk/tobacco/cessation-fact-sheet',
  },
  {
    id: 21,
    type: 'options',
    question: 'Как часто вы испытываете стресс в повседневной жизни?',
    options: [
        {
          id: 1,
          text: 'Почти всегда',
          value: 0
        },
        {
          id: 2,
          text: 'Часто',
          value: 1
        },
        {
          id: 3,
          text: 'Иногда',
          value: 2
        },
        {
          id: 4,
          text: 'Редко или иногда',
          value: 3
        }
      ],
    description: 'На основе исследований с участием 10 000 человек',
    impact: 'Исследования с участием более 10 000 человек показывают, что хронический психологический стресс значительно вредит здоровью, способствует увеличению воспаления и ускоренному старению клеток, что повышает риски заболеваемости и смертности.',
    rate: 74,
    link: 'https://bmcpublichealth.biomedcentral.com/articles/10.1186/1471-2458-14-9',
  },
  {
    id: 22,
    type: 'options',
    question: 'Насколько негативно ваше психическое здоровье влияет на ваше благополучие?',
    options: [
        {
          id: 1,
          text: 'Сильно',
          value: 0
        },
        {
          id: 2,
          text: 'Умеренно',
          value: 1
        },
        {
          id: 3,
          text: 'Слабо',
          value: 2
        },
        {
          id: 4,
          text: 'Совсем не влияет',
          value: 3
        }
      ],
    description: 'На основе 10 когортных исследований с участием 68 222 человек',
    impact: 'Исследование, проведенное с участием 68 222 человек в рамках 10 крупных когортных исследований, показывает, что даже низкий уровень психологического стресса значительно увеличивает риск смерти от всех причин.',
    rate: 74,
    link: 'https://www.bmj.com/content/345/bmj.e4933',
  },
  {
    id: 23,
    type: 'options',
    question: 'Как часто вы проходите общие медицинские осмотры у врача?',
    options: [
        {
          id: 1,
          text: 'Никогда',
          value: 0
        },
        {
          id: 2,
          text: 'Каждые 5 лет',
          value: 1
        },
        {
          id: 3,
          text: 'Каждые 2-3 года',
          value: 2
        },
        {
          id: 4,
          text: 'Ежегодно',
          value: 3
        }
      ],
    description: 'На основе 14 исследований, 182 880 участников',
    impact: 'Исследования, основанные на 14 экспериментах с участием 182 880 человек, показывают, что регулярные медицинские осмотры полезны для профилактики заболеваний, ранней диагностики и общего управления здоровьем.',
    rate: 74,
    link: 'https://www.bmj.com/content/345/bmj.e7191',
  },
  {
    id: 24,
    type: 'options',
    question: 'Как часто вы проходите рекомендуемые обследования на рак?',
    options: [
        {
          id: 1,
          text: 'Никогда',
          value: 0
        },
        {
          id: 2,
          text: '1-2 раза в год',
          value: 1
        },
        {
          id: 3,
          text: 'Реже 1 раза в год',
          value: 2
        },
        {
          id: 4,
          text: 'По рекомендациям врача',
          value: 3
        }
      ],
    description: 'На основе 18 рандомизированных клинических исследований, 2,1 миллиона участников',
    impact: 'Исследования, основанные на 18 долгосрочных рандомизированных клинических экспериментах с участием 2,1 миллиона человек, показывают, что обследование на рак толстой кишки, предстательной железы и легких может увеличить продолжительность жизни.',
    rate: 74,
    link: 'https://jamanetwork.com/journals/jamainternalmedicine/article-abstract/2808648',
  },
  {
    id: 25,
    type: 'options',
    question: 'Какова средняя продолжительность жизни ваших биологических бабушек и дедушек или их текущий возраст, если они живы?',
    options: [
        {
          id: 1,
          text: 'Меньше 70',
          value: 0
        },
        {
          id: 2,
          text: '70-79',
          value: 1
        },
        {
          id: 3,
          text: '80-89',
          value: 2
        },
        {
          id: 4,
          text: '90+',
          value: 3
        }
      ],
    description: 'На основе метаанализа, влияние на продолжительность жизни',
    impact: 'Широко цитируемый метаанализ предполагает, что генетические факторы существенно влияют на человеческое долголетие, а продолжительность жизни бабушек и дедушек заметно влияет на их потомков.',
    rate: 74,
    link: 'https://www.intechopen.com/chapters/55982',
  },
  {
    id: 26,
    type: 'options',
    question: 'У Вас есть избыточный вес?',
    options: [
        {
          id: 1,
          text: 'Ожирение',
          value: 0
        },
        {
          id: 2,
          text: 'Избыточный вес',
          value: 1
        },
        {
          id: 3,
          text: 'Небольшой избыточный вес',
          value: 2
        },
        {
          id: 4,
          text: 'Нет',
          value: 3
        }
      ],
    description: 'Основано на 230 когортных исследованиях с участием 30,3 миллиона человек',
    impact: 'Исследования 230 когортных исследований с участием более 30,3 миллиона человек показывают, что каждые 5 единиц увеличения ИМТ выше 25 существенно увеличивают риск смерти от всех причин.',
    rate: 74,
    link: 'https://www.bmj.com/content/353/bmj.i2156',
  },
  {
    id: 27,
    type: 'options',
    question: 'Какое у вас обычно артериальное давление?',
    options: [
        {
          id: 1,
          text: '140/90 или выше (Высокое)',
          value: 0
        },
        {
          id: 2,
          text: '120/80 до 139/89 (Повышенное)',
          value: 1
        },
        {
          id: 3,
          text: 'Ниже 120/80 (Нормальное)',
          value: 2
        },
        {
          id: 4,
          text: 'Не знаю',
          value: 3
        }
      ],
    description: 'Основано на 61 исследовании с участием более 1 миллиона человек',
    impact: 'Мета-анализ 61 исследования с участием более 1 миллиона человек демонстрирует, что высокое артериальное давление значительно увеличивает риск сердечно-сосудистых заболеваний, инсульта и смертности.',
    rate: 74,
    link: 'https',
  },
  {
    id: 28,
    type: 'options',
    question: 'Каков уровень вашего "плохого" (ЛПНП) холестерина?',
    options: [
        {
          id: 1,
          text: '160 мг/дл или выше (Высокий)',
          value: 0
        },
        {
          id: 2,
          text: '100-159 мг/дл (Выше среднего)',
          value: 1
        },
        {
          id: 3,
          text: 'Ниже 100 мг/дл (Оптимальный)',
          value: 2
        },
        {
          id: 4,
          text: 'Не знаю',
          value: 3
        }
      ],
    description: 'Основано на 74 исследованиях с участием 2,5 миллиона человек',
    impact: 'Исследования 74 исследований с участием более 2,5 миллиона человек показывают, что сердечно-сосудистые заболевания значительно сокращают продолжительность жизни, в среднем уменьшая её на несколько лет.',
    rate: 74,
    link: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0284052',
  },
  {
    id: 29,
    type: 'options',
    question: 'Какой у вас уровень глюкозы в крови натощак?',
    options: [
        {
          id: 1,
          text: '126 мг/дл и выше (Диабет)',
          value: 0
        },
        {
          id: 2,
          text: '100–125 мг/дл (Преддиабет)',
          value: 1
        },
        {
          id: 3,
          text: 'Ниже 100 мг/дл (Норма)',
          value: 2
        },
        {
          id: 4,
          text: 'Не знаю',
          value: 3
        }
      ],
    description: 'На основе 100 исследований, 800 000 участников',
    impact: 'Исследования, основанные на 100+ работах с участием более 800 000 человек, показывают, что диабет почти вдвое увеличивает риск смертности от всех причин.',
    rate: 74,
    link: 'https://www.hindawi.com/journals/jdr/2020/5767582/',
  },
  {
    id: 30,
    type: 'options',
    question: 'Есть ли у вас хронические заболевания?',
    options: [
        {
          id: 1,
          text: 'Да',
          value: 0
        },
        {
          id: 2,
          text: 'Есть факторы риска заболевания',
          value: 1
        },
        {
          id: 3,
          text: 'Нет',
          value: 2
        },
        {
          id: 4,
          text: 'Не уверен',
          value: 3
        }
      ],
    description: 'На основе 37 исследований',
    impact: 'Исследования на основе 37 работ о хронических состояниях показывают, что они значительно сокращают продолжительность жизни.',
    rate: 74,
    link: 'https://journals.plos.org/globalpublichealth/article?id=10.1371/journal.pgph.0000745',
  },
];
